<div *ngIf="serverRequest">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>build</mat-icon>
      {{
        serverRequest.id ? "Server Request - " + serverRequest.serverName : "Create new Server Request"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="validatingCompany || companyValidationFailed || parentMismatch || !hasRequiredSelections || !form.form.valid"
      >
        <mat-icon>{{ serverRequest.id ? "save" : "add" }}</mat-icon>
        {{ serverRequest.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="serverRequest.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <p *ngIf="companyValidationFailed">
      Unable to validate the selected records for this company.
      <button mat-button type="button" (click)="validateCompanySelections()">Retry</button>
    </p>
    <p *ngIf="parentMismatch">
      The server request must use its parent hardware request and company.
      <button mat-button type="button" (click)="useParentHardwareRequest()">Use parent hardware request</button>
    </p>
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Server Request Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [companyId]="serverRequest.companyId" (companyIdChange)="onCompanyChange($event)" [disabled]="!!hardwareRequestId" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="requestId"
                [model]="requestId"
                label="Hardware Request"
              ></micro-valid-label>
            </th>
            <td style="padding: 5px;">
              <micro-select-pagination
                apiUrl="/domain/cmdbHardwareRequests"
                routerBase="/hardwareRequests"
                [(id)]="serverRequest.requestId"
                [params]="{companyId: serverRequest.companyId}"
                [disabled]="!!hardwareRequestId || validatingCompany || parentMismatch || !serverRequest.companyId"
                [defaultOption]="selectedValues.requestId"
                placeholder="Select request"
                (objectChange)="onHardwareRequestChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>Requested By</th>
            <td style="padding: 5px;">
              <micro-user-lookup [userId]="serverRequest.requestedBy"></micro-user-lookup>
            </td>
          </tr>
          <tr><th>Environment</th><td><micro-environment-select [(environmentId)]="serverRequest.environmentId" [companyId]="serverRequest.companyId" [disabled]="validatingCompany || parentMismatch || !serverRequest.companyId" [required]="true"></micro-environment-select></td></tr>
          <tr>
            <th>Server Size</th>
            <td>
                <micro-select-combo
                    [placeholder]="'Select server size'"
                    [mode]="'simple'"
                    [(id)]="serverRequest.serverSize"
                    (idChange)="onSelectedChange('serverSize', $event)"
                    [options]="[
                      {
                        id: 'Small',
                        name: 'Small',
                        value: 'Small',
                      },
                      {
                        id: 'Medium',
                        name: 'Medium',
                        value: 'Medium',
                      },
                      {
                        id: 'Large',
                        name: 'Large',
                        value: 'Large',
                      }
                    ]"
                    [loading]="false"
                    [required]="true"
                    [jump]="true"
                    [pickList]="false"
                    [disabled]="false"
              ></micro-select-combo>
            </td>
          </tr>
          <tr>
            <th>OS</th>
            <td>
              <!-- <micro-select-pagination
                apiUrl="/domain/cmdbOsFamily?osTypeId={{hardwareRequest.osTypeId}}"
                routerBase="/os"
                [(id)]="serverRequest.osId"
                [defaultOption]="selectedValues.osId"
                placeholder="Select OS"
                (objectChange)="onOsChange($event)"
              ></micro-select-pagination> -->
              <micro-select-combo
                [placeholder]="'Select OS'"
                [mode]="'single'"
                [(id)]="serverRequest.osId"
                (objectChange)="onOsChange($event)"
                [options]="osOptions"
                [loading]="validatingCompany"
                [disabled]="validatingCompany || parentMismatch || !serverRequest.companyId || !hardwareRequest?.osTypeId"
                [required]="true"
              ></micro-select-combo>
            </td>
          </tr>
          <tr>
            <th>OS Version</th>
            <td>
              <micro-select-combo
                [placeholder]="'Select OS Version'"
                [mode]="'single'"
                [(id)]="serverRequest.osVersionId"
                (objectChange)="onSelectedChange('osVersionId', $event)"
                [options]="osVersionOptions"
                [loading]="validatingCompany"
                [disabled]="validatingCompany || parentMismatch || !serverRequest.companyId || !hardwareRequest?.osTypeId || !serverRequest.osId"
                [required]="true"
              ></micro-select-combo>
            </td>
          </tr>
          <tr>
            <th>Site</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/sites"
                routerBase="sites"
                [params]="{companyId: serverRequest.companyId}"
                [disabled]="validatingCompany || parentMismatch || !serverRequest.companyId"
                [(id)]="serverRequest.siteId"
                [defaultOption]="selectedValues.siteId"
                placeholder="Select Site"
                [required]="true"
                (objectChange)="onSelectedChange('siteId', $event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="cpu"
                [model]="cpu"
                label="CPU"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #cpu="ngModel"
                [(ngModel)]="serverRequest.cpu"
                required
                id="cpu"
                name="cpu"
                type="number"
                min="0"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="ram"
                [model]="ram"
                label="RAM"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #ram="ngModel"
                [(ngModel)]="serverRequest.ram"
                required
                id="ram"
                name="ram"
                type="number"
                min="0"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="node"
                [model]="node"
                label="Node"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #node="ngModel"
                [(ngModel)]="serverRequest.node"
                required
                id="node"
                name="node"
                type="number"
                min="0"
              />
            </td>
          </tr>
          <tr>
            <th>Hosting Platform</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbHostingPlatform"
                [params]="{companyId: serverRequest.companyId}"
                [disabled]="validatingCompany || parentMismatch || !serverRequest.companyId"
                routerBase="/hostingPlatforms"
                [(id)]="serverRequest.hostingPlatformId"
                [defaultOption]="selectedValues.hostingPlatformId"
                placeholder="Select Hosting Platform"
                (objectChange)="onSelectedChange('hostingPlatformId', $event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="clusterId"
                [model]="clusterId"
                label="Cluster"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #clusterId="ngModel"
                [(ngModel)]="serverRequest.clusterId"
                required
                maxlength="50"
                id="clusterId"
                name="clusterId"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="serverName"
                label="Server Name"
              ></micro-valid-label>
            </th>
            <td>
              <div style="padding: 2px; font-size: 13px;">
                {{serverRequest.serverName}}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
